module.exports = __webpack_public_path__ + "img/icon_plus@2x.ec9b8509.png";